import { Box, Typography, IconButton, Tooltip } from '@mui/material'
import { Close, DeleteOutline, AutoAwesome } from '@mui/icons-material'

const ChatHeader = ({ onClose, onClearHistory, hasMessages }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 2,
        borderBottom: 1,
        borderColor: 'divider',
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <AutoAwesome fontSize="small" />
        <Typography variant="subtitle1" fontWeight="bold">
          Assistente BlocoB3
        </Typography>
      </Box>
      <Box>
        {hasMessages && (
          <Tooltip title="Limpar conversa">
            <IconButton size="small" sx={{ color: 'inherit' }} onClick={onClearHistory}>
              <DeleteOutline fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        <Tooltip title="Fechar">
          <IconButton size="small" sx={{ color: 'inherit' }} onClick={onClose}>
            <Close fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  )
}

export default ChatHeader
